import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import {
  updatePreferenceList,
  updateTelephoneNumber,
} from "../../store/slices/GetStarted/userBasicDataSlice";
import {
  authModalHandler,
  postAddress,
} from "../../store/slices/Preference/studioDetailstSlice";

export const useAddress = () => {
  const dispatch = useDispatch();
  const phoneRegExp = /^[0-9]+$/;

  const addressValidationSchema = Yup.object().shape({
    address: Yup.string()
      .required("Address is required")
      .max(150, "The address field should be 150 charecters long"),
    telephone: Yup.string()
      .min(7, "Telephone number should be at least 7 characters long")
      .max(11, "Telephone number should be at most 11 characters long"),
  });

  const addressSubmit = async (data, resetForm) => {
    const resultAction = await dispatch(postAddress(data));
    if (postAddress.fulfilled.match(resultAction)) {
      dispatch(updateTelephoneNumber(data?.telephone_number));
      resetForm();
      dispatch(authModalHandler(false));
      toast.success("Address Added Successfully", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return {
    addressValidationSchema,
    addressSubmit,
  };
};
